import { Icon, Shadow, Tooltip, HStack } from '@genial/components';
import { Color, Spacing } from '@genial/design-tokens';
import { IconographyTypes } from '@genial/icons';
import { useBreakpointValue } from '@genial/utils';
import React from 'react';

interface TableContentItemCaptionsProps {
  icons: IconographyTypes.Option[];
  forceDesktop?: boolean;
}

type CaptionLabel = {
  title: string;
  color: string;
  backgroundColor?: string;
};

const captionLabels: Record<string, CaptionLabel> = {
  QualifiedClient: {
    title: 'Investidor qualificado',
    color: 'brand.secondary.principal',
  },
  Liquidity: { title: 'Liquidez diária', color: 'brand.primary.principal' },
  IncomeTaxExempt: { title: 'Isento de IR', color: 'brand.tertiary.dark' },
  Fgc: { title: 'Garantia pelo FGC', color: 'feedback.success.default' },
  Locked: { title: 'Fundo fechado', color: 'brand.tertiary.light' },
  ProfessionalInvestor: {
    title: 'Investidor profissional',
    color: 'brand.tertiary.principal',
  },
  EyeOff: {
    title: 'Não visível para o cliente',
    color: 'neutral.white',
    backgroundColor: 'neutral.light',
  },
} as const;

export const TableContentItemCaptions: React.FC<TableContentItemCaptionsProps> = ({
  icons,
  forceDesktop,
}) => {
  const isDesktopLayout = useBreakpointValue({ base: false, lg: true });
  const isDesktop = forceDesktop ?? isDesktopLayout;
  const tooltipIsDisabled = forceDesktop ?? isDesktop;
  const iconSize = isDesktop ? 'xs' : 'sm';
  return (
    <HStack alignItems="center" space={Spacing['inline.nano']}>
      {icons.map((icon) => {
        const caption = captionLabels[icon];
        return (
          <Tooltip label={caption.title} key={icon} isDisabled={tooltipIsDisabled}>
            <Shadow level={1} rounded="full">
              <Icon
                name={icon}
                size={iconSize}
                variant="rounded"
                color={Color[caption.color]}
                {...(caption.backgroundColor && {
                  backgroundColor: Color[caption.backgroundColor],
                })}
              />
            </Shadow>
          </Tooltip>
        );
      })}
    </HStack>
  );
};
